module.exports = __webpack_public_path__ + "img/loading.71e05224.gif";